import { ITranslation } from './ITranslation';

export enum TranslationGroupStatus {
    Created = 'created',
    Validating = 'validating',
    PartialDone = 'partial-done',
    Done = 'done',
    Error = 'error',
    Uploading = 'uploading',
}

export interface ITranslationGroup {
    id: string;
    owner_id: string;
    name: string;
    status: TranslationGroupStatus;
    thumbnail_url: string;
    created_by: string;
    created_at: string;
    modified_at: string;
    generated_at?: string;
    target_languages: string[];
    subtitles_url: string;
    source_url: string;
    source_language?: string;
    duration?: number;
    persist?: boolean;
    error_kind?: string;
    translations?: GroupTranslation[];
    proofreading?: boolean;
}

export type GroupTranslation = Pick<
    ITranslation,
    | 'id'
    | 'status'
    | 'generated_at'
    | 'modified_at'
    | 'proofreading'
    | 'locale'
    | 'language'
    | 'custom_voice_id'
    | 'transcriptions'
>;
